import { HomePage } from '@/pages/home'

export default HomePage

export { getStaticPaths, getStaticProps } from '@/shared/lib/next'
